module.exports = __webpack_public_path__ + "media/images/img_service_problem_2-d092ceec7cd5f8d43d99b3ac4c9a506e.png";